export default "__VITE_ASSET__BEAt8dMT__"